// extracted by mini-css-extract-plugin
export var alert = "alert-module--alert--2kW32";
export var alertBody = "alert-module--alertBody--aEMwt";
export var alertHeadline = "alert-module--alertHeadline--1QBG3";